__turbopack_context__.v({
  "birdeyePhoneRow": "MediaText-module__IXyBgq__birdeyePhoneRow",
  "compact": "MediaText-module__IXyBgq__compact",
  "content": "MediaText-module__IXyBgq__content",
  "eyebrow": "MediaText-module__IXyBgq__eyebrow",
  "fiveSixthsContent": "MediaText-module__IXyBgq__fiveSixthsContent",
  "jumbotronVideo": "MediaText-module__IXyBgq__jumbotronVideo",
  "media": "MediaText-module__IXyBgq__media",
  "noSpacing": "MediaText-module__IXyBgq__noSpacing",
  "row": "MediaText-module__IXyBgq__row",
  "sevenTwelfthsMedia": "MediaText-module__IXyBgq__sevenTwelfthsMedia",
  "threeQuartersContent": "MediaText-module__IXyBgq__threeQuartersContent",
  "threeQuartersMedia": "MediaText-module__IXyBgq__threeQuartersMedia",
  "twoThirdsContent": "MediaText-module__IXyBgq__twoThirdsContent",
  "twoThirdsMedia": "MediaText-module__IXyBgq__twoThirdsMedia",
});
